//pomocné fce napříč projektem

export function CapitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function ConvertImageUriFromS3ToCloudFront(s3uri){
  return s3uri.replace('topasplus-public.s3-eu-west-1.amazonaws.com', 'topasplus.cz');
}
